import React, { useState, useEffect } from 'react';
import { X, Save, Building2 } from 'lucide-react';
import Select from 'react-select';
import { supplierService } from '../services/api';
import api from '../services/api';

function SupplierForm({ onClose, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [serviceCategories, setServiceCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);

  const [formData, setFormData] = useState({
    supplier_name: '',
    service_category: '',
    contact_person: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    country: 'South Africa',
    bank_name: '',
    account_holder: '',
    account_number: '',
    branch_code: '',
    swift_code: '',
    currency: 'ZAR',
  });

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await api.get('/api/service-categories/');
        const data = response.data;
        const categories = Array.isArray(data) ? data : (Array.isArray(data.results) ? data.results : []);
        setServiceCategories(categories);
        if (categories.length > 0) {
          setFormData(prev => ({ ...prev, service_category: categories[0].id }));
        }
      } catch (err) {
        console.error('Failed to load service categories:', err);
        setServiceCategories([]);
      } finally {
        setCategoriesLoading(false);
      }
    };
    fetchCategories();
  }, []);

  const CURRENCIES = [
    { value: 'ZAR', label: 'ZAR - South African Rand' },
    { value: 'USD', label: 'USD - US Dollar' },
    { value: 'EUR', label: 'EUR - Euro' },
    { value: 'GBP', label: 'GBP - British Pound' },
    { value: 'AUD', label: 'AUD - Australian Dollar' },
    { value: 'NZD', label: 'NZD - New Zealand Dollar' },
    { value: 'MUR', label: 'MUR - Mauritian Rupee' },
    { value: 'CNY', label: 'CNY - Chinese Yuan' },
    { value: 'JPY', label: 'JPY - Japanese Yen' },
    { value: 'HKD', label: 'HKD - Hong Kong Dollar' },
    { value: 'SGD', label: 'SGD - Singapore Dollar' },
    { value: 'INR', label: 'INR - Indian Rupee' },
    { value: 'AED', label: 'AED - UAE Dirham' },
    { value: 'SAR', label: 'SAR - Saudi Riyal' },
    { value: 'KES', label: 'KES - Kenyan Shilling' },
    { value: 'NGN', label: 'NGN - Nigerian Naira' },
    { value: 'CAD', label: 'CAD - Canadian Dollar' },
    { value: 'CHF', label: 'CHF - Swiss Franc' },
  ];

  const COUNTRIES = [
    { value: 'Afghanistan', label: 'Afghanistan' },
    { value: 'Albania', label: 'Albania' },
    { value: 'Algeria', label: 'Algeria' },
    { value: 'Andorra', label: 'Andorra' },
    { value: 'Angola', label: 'Angola' },
    { value: 'Argentina', label: 'Argentina' },
    { value: 'Australia', label: 'Australia' },
    { value: 'Austria', label: 'Austria' },
    { value: 'Bahrain', label: 'Bahrain' },
    { value: 'Bangladesh', label: 'Bangladesh' },
    { value: 'Belgium', label: 'Belgium' },
    { value: 'Botswana', label: 'Botswana' },
    { value: 'Brazil', label: 'Brazil' },
    { value: 'Canada', label: 'Canada' },
    { value: 'Chile', label: 'Chile' },
    { value: 'China', label: 'China' },
    { value: 'Colombia', label: 'Colombia' },
    { value: 'Croatia', label: 'Croatia' },
    { value: 'Czech Republic', label: 'Czech Republic' },
    { value: 'Denmark', label: 'Denmark' },
    { value: 'Egypt', label: 'Egypt' },
    { value: 'Estonia', label: 'Estonia' },
    { value: 'Ethiopia', label: 'Ethiopia' },
    { value: 'Finland', label: 'Finland' },
    { value: 'France', label: 'France' },
    { value: 'Germany', label: 'Germany' },
    { value: 'Ghana', label: 'Ghana' },
    { value: 'Greece', label: 'Greece' },
    { value: 'Hong Kong', label: 'Hong Kong' },
    { value: 'Hungary', label: 'Hungary' },
    { value: 'Iceland', label: 'Iceland' },
    { value: 'India', label: 'India' },
    { value: 'Indonesia', label: 'Indonesia' },
    { value: 'Ireland', label: 'Ireland' },
    { value: 'Israel', label: 'Israel' },
    { value: 'Italy', label: 'Italy' },
    { value: 'Japan', label: 'Japan' },
    { value: 'Jordan', label: 'Jordan' },
    { value: 'Kenya', label: 'Kenya' },
    { value: 'Kuwait', label: 'Kuwait' },
    { value: 'Latvia', label: 'Latvia' },
    { value: 'Lebanon', label: 'Lebanon' },
    { value: 'Lesotho', label: 'Lesotho' },
    { value: 'Lithuania', label: 'Lithuania' },
    { value: 'Luxembourg', label: 'Luxembourg' },
    { value: 'Madagascar', label: 'Madagascar' },
    { value: 'Malawi', label: 'Malawi' },
    { value: 'Malaysia', label: 'Malaysia' },
    { value: 'Mauritius', label: 'Mauritius' },
    { value: 'Mexico', label: 'Mexico' },
    { value: 'Morocco', label: 'Morocco' },
    { value: 'Mozambique', label: 'Mozambique' },
    { value: 'Namibia', label: 'Namibia' },
    { value: 'Netherlands', label: 'Netherlands' },
    { value: 'New Zealand', label: 'New Zealand' },
    { value: 'Nigeria', label: 'Nigeria' },
    { value: 'Norway', label: 'Norway' },
    { value: 'Oman', label: 'Oman' },
    { value: 'Pakistan', label: 'Pakistan' },
    { value: 'Peru', label: 'Peru' },
    { value: 'Philippines', label: 'Philippines' },
    { value: 'Poland', label: 'Poland' },
    { value: 'Portugal', label: 'Portugal' },
    { value: 'Qatar', label: 'Qatar' },
    { value: 'Romania', label: 'Romania' },
    { value: 'Russia', label: 'Russia' },
    { value: 'Rwanda', label: 'Rwanda' },
    { value: 'Saudi Arabia', label: 'Saudi Arabia' },
    { value: 'Senegal', label: 'Senegal' },
    { value: 'Singapore', label: 'Singapore' },
    { value: 'Slovakia', label: 'Slovakia' },
    { value: 'Slovenia', label: 'Slovenia' },
    { value: 'South Africa', label: 'South Africa' },
    { value: 'South Korea', label: 'South Korea' },
    { value: 'Spain', label: 'Spain' },
    { value: 'Sri Lanka', label: 'Sri Lanka' },
    { value: 'Eswatini', label: 'Eswatini' },
    { value: 'Sweden', label: 'Sweden' },
    { value: 'Switzerland', label: 'Switzerland' },
    { value: 'Taiwan', label: 'Taiwan' },
    { value: 'Tanzania', label: 'Tanzania' },
    { value: 'Thailand', label: 'Thailand' },
    { value: 'Tunisia', label: 'Tunisia' },
    { value: 'Turkey', label: 'Turkey' },
    { value: 'Uganda', label: 'Uganda' },
    { value: 'Ukraine', label: 'Ukraine' },
    { value: 'United Arab Emirates', label: 'United Arab Emirates' },
    { value: 'United Kingdom', label: 'United Kingdom' },
    { value: 'United States', label: 'United States' },
    { value: 'Vietnam', label: 'Vietnam' },
    { value: 'Zambia', label: 'Zambia' },
    { value: 'Zimbabwe', label: 'Zimbabwe' },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCountryChange = (selectedOption) => {
    setFormData(prev => ({ ...prev, country: selectedOption ? selectedOption.value : '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await supplierService.create(formData);
      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error creating supplier:', err);
      if (err.response?.data) {
        const errors = err.response.data;
        const errorMessages = Object.entries(errors)
          .map(([field, msgs]) => `${field}: ${Array.isArray(msgs) ? msgs.join(', ') : msgs}`)
          .join('\n');
        setError(errorMessages);
      } else {
        setError('Failed to create supplier. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.2s',
  };

  const labelStyle = {
    display: 'block',
    fontSize: '13px',
    fontWeight: '500',
    color: '#374151',
    marginBottom: '6px',
  };

  const sectionStyle = { marginBottom: '24px' };

  const sectionTitleStyle = {
    fontSize: '14px',
    fontWeight: '600',
    color: '#1e293b',
    marginBottom: '16px',
    paddingBottom: '8px',
    borderBottom: '1px solid #e2e8f0',
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
  };

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '42px',
      borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
      borderRadius: '8px',
      boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
      '&:hover': { borderColor: '#3b82f6' },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#dbeafe' : 'white',
      color: state.isSelected ? 'white' : '#374151',
      cursor: 'pointer',
    }),
    placeholder: (base) => ({ ...base, color: '#9ca3af' }),
    menu: (base) => ({
      ...base,
      borderRadius: '8px',
      boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
      zIndex: 9999,
    }),
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex', justifyContent: 'center', alignItems: 'flex-start',
      padding: '40px 20px', overflowY: 'auto', zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white', borderRadius: '16px',
        width: '100%', maxWidth: '700px', maxHeight: '90vh',
        overflow: 'hidden', display: 'flex', flexDirection: 'column',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '20px 24px', borderBottom: '1px solid #e2e8f0',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '40px', height: '40px', backgroundColor: '#dbeafe',
              borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <Building2 size={20} color="#3b82f6" />
            </div>
            <div>
              <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: '#1e293b' }}>
                Add New Supplier
              </h2>
              <p style={{ margin: 0, fontSize: '13px', color: '#64748b' }}>
                Fill in the supplier details below
              </p>
            </div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px', borderRadius: '8px' }}>
            <X size={20} color="#64748b" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ padding: '24px', overflowY: 'auto', flex: 1 }}>
          {error && (
            <div style={{
              padding: '12px 16px', backgroundColor: '#fee2e2', color: '#991b1b',
              borderRadius: '8px', marginBottom: '20px', fontSize: '14px', whiteSpace: 'pre-line',
            }}>
              {error}
            </div>
          )}

          {/* Basic Information */}
          <div style={sectionStyle}>
            <h3 style={sectionTitleStyle}>Basic Information</h3>
            <div style={gridStyle}>
              <div style={{ gridColumn: 'span 2' }}>
                <label style={labelStyle}>Supplier Name *</label>
                <input type="text" name="supplier_name" value={formData.supplier_name}
                  onChange={handleChange} required style={inputStyle} placeholder="Enter supplier name" />
              </div>
              <div>
                <label style={labelStyle}>Service Category *</label>
                <select name="service_category" value={formData.service_category}
                  onChange={handleChange} style={inputStyle} disabled={categoriesLoading}>
                  {categoriesLoading ? (
                    <option>Loading categories...</option>
                  ) : (
                    serviceCategories.map(cat => (
                      <option key={cat.id} value={cat.id}>{cat.name}</option>
                    ))
                  )}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Contact Person</label>
                <input type="text" name="contact_person" value={formData.contact_person}
                  onChange={handleChange} style={inputStyle} placeholder="Contact name" />
              </div>
              <div>
                <label style={labelStyle}>Email *</label>
                <input type="email" name="email" value={formData.email}
                  onChange={handleChange} required style={inputStyle} placeholder="email@example.com" />
              </div>
              <div>
                <label style={labelStyle}>Phone</label>
                <input type="text" name="phone" value={formData.phone}
                  onChange={handleChange} style={inputStyle} placeholder="+27 11 123 4567" />
              </div>
            </div>
          </div>

          {/* Location */}
          <div style={sectionStyle}>
            <h3 style={sectionTitleStyle}>Location</h3>
            <div style={gridStyle}>
              <div style={{ gridColumn: 'span 2' }}>
                <label style={labelStyle}>Address</label>
                <input type="text" name="address" value={formData.address}
                  onChange={handleChange} style={inputStyle} placeholder="Street address" />
              </div>
              <div>
                <label style={labelStyle}>City</label>
                <input type="text" name="city" value={formData.city}
                  onChange={handleChange} style={inputStyle} placeholder="City" />
              </div>
              <div>
                <label style={labelStyle}>Country</label>
                <Select options={COUNTRIES} value={COUNTRIES.find(c => c.value === formData.country) || null}
                  onChange={handleCountryChange} styles={selectStyles}
                  placeholder="Select country..." isClearable isSearchable />
              </div>
            </div>
          </div>

          {/* Banking Details */}
          <div style={sectionStyle}>
            <h3 style={sectionTitleStyle}>Banking Details</h3>
            <div style={gridStyle}>
              <div>
                <label style={labelStyle}>Bank Name *</label>
                <input type="text" name="bank_name" value={formData.bank_name}
                  onChange={handleChange} required style={inputStyle} placeholder="Bank name" />
              </div>
              <div>
                <label style={labelStyle}>Account Holder *</label>
                <input type="text" name="account_holder" value={formData.account_holder}
                  onChange={handleChange} required style={inputStyle} placeholder="Account holder name" />
              </div>
              <div>
                <label style={labelStyle}>Account Number *</label>
                <input type="text" name="account_number" value={formData.account_number}
                  onChange={handleChange} required style={inputStyle} placeholder="Account number" />
              </div>
              <div>
                <label style={labelStyle}>Branch Code</label>
                <input type="text" name="branch_code" value={formData.branch_code}
                  onChange={handleChange} style={inputStyle} placeholder="Branch code" />
              </div>
              <div>
                <label style={labelStyle}>SWIFT Code</label>
                <input type="text" name="swift_code" value={formData.swift_code}
                  onChange={handleChange} style={inputStyle} placeholder="SWIFT/BIC code" />
              </div>
              <div>
                <label style={labelStyle}>Currency *</label>
                <select name="currency" value={formData.currency} onChange={handleChange} style={inputStyle}>
                  {CURRENCIES.map(curr => (
                    <option key={curr.value} value={curr.value}>{curr.label}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </form>

        {/* Footer */}
        <div style={{
          display: 'flex', justifyContent: 'flex-end', gap: '12px',
          padding: '16px 24px', borderTop: '1px solid #e2e8f0', backgroundColor: '#f8fafc',
        }}>
          <button type="button" onClick={onClose} style={{
            padding: '10px 20px', backgroundColor: 'white', color: '#475569',
            border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px',
            fontWeight: '500', cursor: 'pointer',
          }}>
            Cancel
          </button>
          <button onClick={handleSubmit} disabled={loading} style={{
            display: 'flex', alignItems: 'center', gap: '8px',
            padding: '10px 20px', backgroundColor: loading ? '#93c5fd' : '#3b82f6',
            color: 'white', border: 'none', borderRadius: '8px',
            fontSize: '14px', fontWeight: '500', cursor: loading ? 'not-allowed' : 'pointer',
          }}>
            <Save size={16} />
            {loading ? 'Saving...' : 'Save Supplier'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SupplierForm;